import { render, staticRenderFns } from "./SoftwareComponentHelpers.vue?vue&type=template&id=10c5c2e7&scoped=true&"
import script from "./SoftwareComponentHelpers.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentHelpers.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentHelpers.vue?vue&type=style&index=0&id=10c5c2e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5c2e7",
  null
  
)

export default component.exports